export class Storage {
  key: string;
  object: any;


  constructor(key: string, object: any) {
    this.key = key;
    this.object = object;
  }
}
